// @generated by protoc-gen-es v2.6.3 with parameter "keep_empty_files=true,target=js+dts"
// @generated from file proto/model/core/place_types/place_type.proto (package carmen, syntax proto3)
/* eslint-disable */

import { enumDesc, fileDesc, tsEnum } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file proto/model/core/place_types/place_type.proto.
 */
export const file_proto_model_core_place_types_place_type = /*@__PURE__*/
  fileDesc("Ci1wcm90by9tb2RlbC9jb3JlL3BsYWNlX3R5cGVzL3BsYWNlX3R5cGUucHJvdG8SBmNhcm1lbirJBAoJUGxhY2VUeXBlEhoKFlBMQUNFX1RZUEVfVU5TUEVDSUZJRUQQABIZChVQTEFDRV9UWVBFX0FVVE9NT1RJVkUQARIXChNQTEFDRV9UWVBFX0JVU0lORVNTEAISFgoSUExBQ0VfVFlQRV9DVUxUVVJFEAMSGAoUUExBQ0VfVFlQRV9FRFVDQVRJT04QBBIrCidQTEFDRV9UWVBFX0VOVEVSVEFJTk1FTlRfQU5EX1JFQ1JFQVRJT04QBRIZChVQTEFDRV9UWVBFX0ZBQ0lMSVRJRVMQBhIWChJQTEFDRV9UWVBFX0ZJTkFOQ0UQBxIdChlQTEFDRV9UWVBFX0ZPT0RfQU5EX0RSSU5LEAgSIQodUExBQ0VfVFlQRV9HRU9HUkFQSElDQUxfQVJFQVMQCRIZChVQTEFDRV9UWVBFX0dPVkVSTk1FTlQQChIiCh5QTEFDRV9UWVBFX0hFQUxUSF9BTkRfV0VMTE5FU1MQCxIWChJQTEFDRV9UWVBFX0hPVVNJTkcQDBIWChJQTEFDRV9UWVBFX0xPREdJTkcQDRIfChtQTEFDRV9UWVBFX05BVFVSQUxfRkVBVFVSRVMQDhIgChxQTEFDRV9UWVBFX1BMQUNFU19PRl9XT1JTSElQEA8SFwoTUExBQ0VfVFlQRV9TRVJWSUNFUxAQEhcKE1BMQUNFX1RZUEVfU0hPUFBJTkcQERIVChFQTEFDRV9UWVBFX1NQT1JUUxASEh0KGVBMQUNFX1RZUEVfVFJBTlNQT1JUQVRJT04QE0IoWiZnaXRodWIuY29tL3l1bmFjYWJhL2Nhcm1lbi9wcm90by9tb2RlbGIGcHJvdG8z");

/**
 * Describes the enum carmen.PlaceType.
 */
export const PlaceTypeSchema = /*@__PURE__*/
  enumDesc(file_proto_model_core_place_types_place_type, 0);

/**
 * Base categorization of place types
 *
 * @generated from enum carmen.PlaceType
 */
export const PlaceType = /*@__PURE__*/
  tsEnum(PlaceTypeSchema);

